import React, { Component } from 'react';

import PropTypes from 'prop-types';

import{FormattedDate} from "react-intl";

import{FormattedTime} from "react-intl";

class Evento extends Component {

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {
      date: Date.now()
    };
  }


  stripHTMLTags = (text) => {
    console.log(text);
    if(text === null || text === ''){
      return '';
    }
    else{
      let description = text;
      description = description.replace(/<[^>]*>/g, '');
      description = description.replace(/(?:^|\W)&nbsp(?:$|\W)/, '');
      if(description.length > 80){
        description = description.substr(0, 80) + "\u2026";
      }
      
      return description;
    }
  }

  isInscricaoAvailable = () => {
    
    let isInTime = Date.now() < Date.parse(this.props.evento.startDate);
    
    if(this.props.evento !== null && this.props.evento.permiteInscricao && isInTime) {
      return true;
    } else{
      return false;
    }

  }

  eventClicked = () => {
    this.context.router.history.push("/noticias_e_eventos/" + this.props.evento.identifier);
  }

  render() {

    return (
      
      <div className="col-12 col-lg-6">
        <div onClick={this.eventClicked} className="evento box-shadow">

            <div className="col-6 col-lg-5 imagem-evento">
              <img alt="" src={this.props.evento.mainPhoto}></img>
            </div>
            <div className="col-6 col-lg-7 event-info">
              <h3>{this.props.evento.title}</h3>
              

              
              <div className="div-icons">
                <i className="far fa-calendar-alt"></i>
                <span>
                  <FormattedDate
                    value={new Date(this.props.evento.startDate)}
                    year='numeric'
                    month='long'
                    day='2-digit'
                  />
                  
                </span>
              </div>
              {
              this.props.evento.startTime !== undefined && this.props.evento.startTime !== "" &&
                
                <div className="div-icons">
                  <i className="far fa-clock"></i>
                  <span>
                    
                      <FormattedTime value={new Date(this.props.evento.startTime)} /> h
                    
                  </span>
                </div>
                
              }


              <div className="div-icons">
                <i className="fas fa-map-marked-alt"></i>
                <span>{this.props.evento.location}</span>
              </div>
              
              
              {this.isInscricaoAvailable() ? 
                <div className="div-icons">
                  <i className="fas fa-user-plus"></i>
                  <span>Inscrição Disponível</span>
                </div>
                :
                null
            }

              


              {/* <Botao isPositionAbsolute={true}></Botao>*/}
            </div>

        </div>
      </div>

    )
  }
}

export default Evento;
